export enum ERouterList {
  HOME = 'Home',
  PLACEHOLDER = 'Placeholder',
  LOGIN = 'Login',
  LOGIN_EMAIL = 'LoginEmail',
  NEW_PASSWORD = 'NewPassword',
  MFA_VRF = 'TwoFactorVerification',
  MFA_VRF_CODE = 'TwoFactorVerificationCode',
  FORGOT_PASSWORD = 'ForgotPassword',
  FORGOT_PASSWORD_VRF = 'ForgotPasswordVerification',
  NO_EMAIL = 'DontHaveEmail',
  CREATING_ACCOUNT_VIA_LINK = 'CreatingAccountViaLink',
  REQUEST_SENT = 'RequestSent',
  TEMBO_USERS = 'TemboUsers',
  TEMBO_USERS_CREATE = 'TemboUserCreate',
  TEMBO_USERS_PROFILE = 'TemboUserProfile',
  TEMBO_USERS_PROFILE_EDIT = 'TemboUserProfileEdit',
  DCM = 'DCM',
  SETTINGS = 'Settings',
  SETTINGS_EDIT = 'SettingsEdit',
  SEARCH = 'Search',
  VISITS = 'Visits',
  VISITS_LOCATION = 'Visits_LOCATION',
  VISIT = 'Visit',
  VISIT_SCHEDULE = 'VisitSchedule',
  VISIT_MEETING_PREVIEW = 'VisitMeetingPreview',
  VISIT_MEETING = 'VisitMeeting',
  VISIT_DOCUMENT = 'VisitDocument',
  VISIT_ADD_FILES = 'VisitAddFiles',
  VISIT_MANAGE_FILES = 'VisitManageFiles',
  VISIT_SURVEY = 'VisitSurvey',
  VISITS_FILTER = 'VisitsFilter',
  SINGLE_RESIDENT = 'Resident',
  ORGANIZATIONS = 'Organizations',
  ORGANIZATIONS_CREATE = 'OrganizationsCreate',
  ORGANIZATION = 'Organization',
  ORGANIZATION_ADMIN = 'OrganizationAdmin',
  ORGANIZATION_ADMIN_EDIT = 'OrganizationAdminEdit',
  ORGANIZATION_ADMIN_CREATE = 'OrganizationAdminCreate',

  ALERTS = 'Alerts',
  ALERT = 'Alert',
  ALERT_COMPLETE_TASK = 'AlertCompleteTask',
  ALERT_CANCEL_TASK = 'AlertCancelTask',

  MESSAGING = 'Messaging',

  TASKS = 'Tasks',

  LOCATION = 'Location',
  LOCATION_CREATE = 'LocationCreate',
  LOCATION_QR_CODE = 'LocationQrCode',
  LOCATION_EXISTING_USER = 'LocationExistingUser',
  LOCATION_EDIT = 'LocationEdit',
  LOCATION_USER = 'LocationUser',
  LOCATION_USER_CREATE = 'LocationUserCreate',
  LOCATION_USER_EDIT = 'LocationUserEdit',

  ANALYTICS = 'Analytics',
  NOTIFICATIONS = 'Notifications',
  NOTIFICATIONS_REVIEW_CONSENT = 'NotificationsReviewConsent',
  NOTIFICATIONS_REVIEW_INSURANCE = 'NotificationsReviewInsurance',
  NOTIFICATIONS_RESOLVE_DUPLCATE_RESIDENTS = 'NotificationsResolveDuplicateResidents',
  NOT_FOUND = 'NotFound',
  CREATE_NEW_CAMPAIGN = 'CreateNewCampaign',
  CREATE_NEW_MEDIUM = 'CreateNewMedium',
  CLINICIAN_VISIT_HISTORY = 'ClinicianVisitHistory',
  CLINICIAN_VISIT_HISTORY_FILTER = 'ClinicianVisitHistoryFilter',
  VISIT_REMINDER_COMPLETE = 'CompleteVisitReminder',
  VISIT_REMINDER_CANCEL = 'CancelVisitReminder',

  PATIENTS = 'Patients',
  CREATE_PATIENT = 'CreatePatient',
  PATIENTS_ORGANIZATION = 'PatientsOrganization',
  PATIENTS_LOCATION = 'PatientsLocation',
  PATIENTS_LOCATION_PRINT_QR_CODES = 'PatientsLocationPrintQrCodes',
  NEW_PATIENT_PROFILE = 'NewPatientProfile',
  PATIENT_PROFILE = 'PatientProfile',
  EDIT_PATIENT_PROFILE = 'EditPatientProfile',
  NEW_PATIENT_INSURANCE = 'NewPatientInsurance',

  EDIT_PATIENT_INSURANCE = 'EditPatientInsurance',
  EDIT_PATIENT_PROGRAMS_PARTICIPATION = 'EditPatientProgramsParticipation',
  NEW_PATIENT_CONTACT = 'NewPatientContact',
  PATIENT_CONTACT = 'PatientContact',
  NEW_PATIENT_CONSENT = 'NewPatientConsent',
  NEW_PATIENT_CONSENT_SIGN_ONLINE = 'NewPatientConsentSignOnline',
  NEW_PATIENT_CONSENT_UPLOAD_SIGNED = 'NewPatientConsentUploadSigned',
  NEW_PATIENT_CONSENT_VERBAL = 'NewPatientConsentVerbal',
  DECLINE_PATIENT_CONSENT = 'DeclinePatientConsent',
  EDIT_PATIENT_CONTACT = 'EditPatientContact',

  ANONYMOUS_CONSENTS_TOKEN = 'AnonymousConsentsToken',
  ANONYMOUS_CONSENTS_TOKEN_CONSENT_SIGNED = 'AnonymousConsentsTokenConsentSigned',
  ANONYMOUS_CONSENTS_TOKEN_LINK_EXPIRED = 'AnonymousConsentsTokenLinkExpired',
  ANONYMOUS_CONSENTS_TOKEN_LINK_NO_AVAILABLE = 'AnonymousConsentsTokenLinkNoAvailable',
  REDIRECTS = 'Redirects',
}
